<div class="main">
  <router-outlet/>
  <div [style.flex]="1"></div>
</div>